import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  PeerSelectionStatus,
  peerSelectionStatuses,
  PeerSubmissionStatus,
  peerSubmissionStatuses,
  SubmissionStatus,
  submissionStatuses,
  TalkStatus,
  talkStatuses
} from "src/common/types";

const useStyles = makeStyles({
  default: {
    "&:first-letter": {
      textTransform: "capitalize" as "capitalize"
    },
    display: "inline-block" as "inline-block"
  },
  submitted: {
    color: "#1cac67"
  }
});

interface IDefaultProps {
  status: SubmissionStatus | PeerSelectionStatus | PeerSubmissionStatus;
  type: "questionnaire" | "peerSelection" | "peerSummary";
  peerSummaryCountText?: JSX.Element;
  extraText?: string;
}

interface ITalkProps {
  status: TalkStatus;
  type: "talk";
  icName: string;
  dsvName: string;
  extraText?: string;
  peerSummaryCountText?: JSX.Element;
}

type Props = IDefaultProps | ITalkProps;

const Status = (props: Props) => {
  const { status, type, extraText = "" } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [mappedStatus, isSubmitted] = React.useMemo(() => {
    switch (type) {
      case "talk":
        return [talkStatuses[status], status === TalkStatus.Done];
      case "questionnaire":
        return [submissionStatuses[status], status === SubmissionStatus.Submitted];
      case "peerSelection":
        return [peerSelectionStatuses[status], status === PeerSelectionStatus.Submitted];
      case "peerSummary":
        return [peerSubmissionStatuses[status], status === PeerSubmissionStatus.Read];
    }
  }, [type, status]);

  const classNames = React.useMemo(() => {
    return isSubmitted ? [classes.default, classes.submitted].join(" ") : classes.default;
  }, [isSubmitted]);

  const statusText = () => {
    return type === "talk"
      ? t(`feedback.${type}.statuses.${mappedStatus}`, {
          name:
            status === TalkStatus.WaitingForDSVSignature ? (props as ITalkProps).dsvName : (props as ITalkProps).icName
        })
      : t(`feedback.${type}.statuses.${mappedStatus}`);
  };
  return (
    <Typography data-qa-selector="status" variant="body1" display="inline" className={classNames}>
      {statusText() + extraText}
      {/* if status of the talk is not cancelled, then show submission status (3/2) */}
      {status !== TalkStatus.Cancelled && (props as ITalkProps).peerSummaryCountText}
    </Typography>
  );
};

export default React.memo(Status);
